import React from 'react';
import UnlockToast from './UnlockToast';

// The higher the priority, the closer to the top
const PRIORITY_ORDER = { urgent: 0, high: 1, normal: 2, low: 3 };

// Maximum toast stack (if more toasts arrive, oldest ones will be removed)
const MAX_VISIBLE_TOASTS = 4;

const ToastContainer = ({ toasts, onDismiss }) => {
  if (!toasts.length) return null;

  // Sort by priority, then by most recent first
  const sorted = [...toasts]
    .sort((a, b) => {
      const aPriority = PRIORITY_ORDER[a.priority || 'normal'] || 2;
      const bPriority = PRIORITY_ORDER[b.priority || 'normal'] || 2;
      
      // First sort by priority
      if (aPriority !== bPriority) return aPriority - bPriority;
      
      // Then by timestamp (more recent first)
      return b.id - a.id;
    })
    .slice(0, MAX_VISIBLE_TOASTS);

  return (
    <div className="fixed bottom-6 right-6 z-[300] flex flex-col gap-3 items-end pointer-events-none">
      {sorted.map((toast, i) => (
        <div key={toast.id}
          className="pointer-events-auto"
          style={{
            transform: `translateY(${i * -4}px) scale(${1 - i * 0.02})`,
            zIndex: 300 - i,
          }}>
          <UnlockToast toast={toast} onDismiss={onDismiss} />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;